// 검진 데이터들
export const screeningsData = [
  {
    name: "폐암",
    enName: "lung",
    scenario: [
      {
        title: "폐암 조기검진, 받는 것이 좋을까요?",
        running: "00:04",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Flung%2Flung1.mp4?alt=media&token=1b66dd80-1023-4c31-8bdf-bd88b431434d",
      },
      {
        title: "폐암이란?",
        running: "01:26",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Flung%2Flung2.mp4?alt=media&token=18fc77e5-6727-4de4-b849-8aa8be476de9",
      },
      {
        title: "폐암 검진은 무엇인가요?",
        running: "01:14",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Flung%2Flung3.mp4?alt=media&token=d291f432-7bac-4434-bf97-22d9a40cb015",
      },
      {
        title: "폐암 검진의 이득과 손해",
        running: "02:28",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Flung%2Flung4.mp4?alt=media&token=381b4065-adca-41f8-b9a4-8c8752c88b97",
      },
      {
        title: " 국가 폐암 검진",
        running: "00:47",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Flung%2Flung5.mp4?alt=media&token=1582f365-7b53-462c-a9ca-4043cba89e64",
      },
      // {
      //   title: "검진을 받을지 결정하기",
      //   running: "00:00",
      //   url:
      //     "https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buc222k_Bunny_360_10s_1MB.mp4",
      // },
    ],
  },
  {
    name: "전립선암",
    enName: "prostate",
    scenario: [
      {
        title: "전립선암 조기검진, 받는 것이 좋을까요?",
        running: "00:05",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Fprostate%2Fprostate01.mp4?alt=media&token=ad06ddf0-5895-4b7a-9d9a-bd328f94e32b",
      },
      {
        title: "전립선암이란?",
        running: "01:27",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Fprostate%2Fprostate02.mp4?alt=media&token=c61cd1c4-c50b-429d-924f-09965e5ac8be",
      },
      {
        title: "전립선암 검진은 무엇인가요?",
        running: "00:42",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Fprostate%2Fprostate03.mp4?alt=media&token=7c8038a5-76f3-484d-b1b7-dd2271a760d6",
      },
      {
        title: "전립선암 검진의 \n이득과 손해",
        running: "04:59",
        url:
          "https://firebasestorage.googleapis.com/v0/b/rash-form.appspot.com/o/movie%2Fprostate%2Fprostate04.mp4?alt=media&token=85ce90e0-6449-48d2-9627-29c085f85dd0",
      },
      // {
      //   title: "검진을 받을지 결정하기",
      //   running: "00:00",
      //   url:
      //     "http://commondatastorage.googleapis.com/gtv-videos-22bucket/sample/ElephantsDream.mp4",
      // },
    ],
  },
  {
    name: "유방암",
    enName: "breast",
    scenario: [
      {
        title: "유방암 검진, 받는 것이 좋을까요?",
        running: "00:08",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%202%201.mp4?alt=media&token=23118082-9df3-4de0-9050-34cfb71417bb",
      },
      {
        title: "유방암이란?",
        running: "00:08",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%202%201.mp4?alt=media&token=23118082-9df3-4de0-9050-34cfb71417bb",
      },
      {
        title: "유방암 검진은 무엇인가요?",
        running: "00:58",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%202%202.mp4?alt=media&token=f8ebb61d-61c7-43ea-8207-3b6b5fec4b29",
      },
      {
        title: "유방암 검진의 이득과 부정적 측면",
        running: "08:18",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%202%203.mp4?alt=media&token=82efabf2-7479-40cb-8e96-5c6b75cfedfb",
      },
    ],
  },  
  {
    name: "유방암",
    enName: "breast",
    scenario: [
      {
        title: "유방암 검진, 받는 것이 좋을까요?",
        running: "00:08",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%201.mp4?alt=media&token=6a7b5cba-59da-40ad-8039-c9c232369070",
      },
      {
        title: "유방암이란?",
        running: "00:08",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%201.mp4?alt=media&token=6a7b5cba-59da-40ad-8039-c9c232369070",
      },
      {
        title: "유방암 검진은 무엇인가요?",
        running: "00:58",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%202.mp4?alt=media&token=2783da4b-137f-4c91-9c79-dfce68694775",
      },
      {
        title: "유방암 검진의 이득과 부정적 측면",
        running: "08:17",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%203.mp4?alt=media&token=b4d25468-3b2f-4bc8-a5af-7db865f8b8f5",
      },
      {
        title: "연령별 특이사항",
        running: "00:52",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EC%9C%A0%EB%B0%A9%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%204.mp4?alt=media&token=83523730-9e8d-4c1f-9035-670ad120a396",
      },
    ],
  },  
  {
    name: "갑상선암",
    enName: "thyroid",
    scenario: [
      {
        title: "갑상선암 검진, 받는 것이 좋을까요?",
        running: "00:08",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EA%B0%91%EC%83%81%EC%84%A0%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%201.mp4?alt=media&token=b804c123-3285-488b-8b84-992edcda5f6c",
      },
      {
        title: "갑상선암이란?",
        running: "00:08",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EA%B0%91%EC%83%81%EC%84%A0%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%202.mp4?alt=media&token=046ea61b-6aad-44cb-8820-6cbb55e4cf0f",
      },
      {
        title: "갑상선암 검진은 무엇인가요?",
        running: "00:58",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EA%B0%91%EC%83%81%EC%84%A0%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%203.mp4?alt=media&token=a44fd39b-9573-44e9-ac7c-fa7a3200fbfa",
      },
      {
        title: "갑상선암 검진의 이득과 부정적 측면",
        running: "08:18",
        url:
          "https://firebasestorage.googleapis.com/v0/b/cancer-screening-47a69.appspot.com/o/%EA%B0%91%EC%83%81%EC%84%A0%EC%95%94%20%EA%B2%80%EC%A7%84%20%EB%B0%9B%EB%8A%94%20%EA%B2%83%EC%9D%B4%20%EC%A2%8B%EC%9D%84%EA%B9%8C%EC%9A%94%204.mp4?alt=media&token=e451eec5-0571-4c42-b8b4-091da8168b62",
      },
    ],
  },    
];
